// Added to fix UFD-530 (https://vinciworksteam.atlassian.net/browse/UFD-530)

// takes an object containing patches and returns and object or ordered patches
export default function getOrderedPatches(patches) {
  let orderedPatches = [];
  Object.entries(patches).forEach(patch => {
    if (patch[1][0]?.screenIndex) delete patch[1][0].screenIndex;

    // if it's not an advanced patch, just add it to the orderedPatches array
    if (!/^(<|>) *#?(\S+)/.test(patch[0])) {
      orderedPatches.push(patch);
    } else {
      // get the patch type
      const patchType = patch[0].substring(0, 1);
      // get the ID if the page we are patcheing before or after
      const patchBeforeAfterId = patch[0]?.substring(3);

      let splicePosition = -1;
      let firstPatchPosition = 0;

      // find the position to insert the patch
      orderedPatches.forEach((orderedPatch, i) => {
        firstPatchPosition++;
        const orderedPatchId: string = orderedPatch[1][0] || '';

        // get the splice position if there is a match
        if (
          orderedPatchId &&
          orderedPatchId.id &&
          orderedPatchId.id === patchBeforeAfterId
        ) {
          splicePosition = i;
        }
      });

      if (splicePosition !== -1) {
        orderedPatches.splice(
          splicePosition + (patchType === '>' ? 1 : 0),
          0,
          patch
        );
      } else {
        orderedPatches.splice(firstPatchPosition, 0, patch);
      }
    }
  });

  // convert to an object
  return Object.fromEntries(orderedPatches);
}
